import React from 'react';

import {
  Heading,
  Paragraph,
  Main,
  ContentGroup,
  Hr,
  Grid,
  GridItem,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { StyledLink } from 'client/components/styledLink/StyledLink';
import Helmet from 'react-helmet';

import {
  RentersRightsBillContent,
  YouTubeVideo,
} from './RentersRightsBillPage.config';
import * as routes from '../manifest';

export default function RentersRightsBillPage() {
  const { backLabel, metaContent, title, description, videoLinks } =
    useContent<RentersRightsBillContent>();
  return (
    <Main>
      <Helmet>
        <title>{metaContent.title}</title>
      </Helmet>
      <ContentGroup marginTop="05" marginBottom="none">
        <StyledLink
          iconPosition="left"
          data-testid="back-button-link"
          to={routes.LandlordSupport}
        >
          {backLabel}
        </StyledLink>
      </ContentGroup>
      <Heading as="h1" size="s7" marginTop="05">
        {title}
      </Heading>
      <Hr />
      <Paragraph marginBottom="06">{description}</Paragraph>
      <Grid>
        {videoLinks.map((video: YouTubeVideo) => (
          <GridItem sm={12} md={6} key={video.id}>
            <iframe
              src={`https://www.youtube.com/embed/${video.id}`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                minWidth: '100%',
                minHeight: '300px',
              }}
            />
          </GridItem>
        ))}
      </Grid>
    </Main>
  );
}
